import { Box } from '@mantine/core';
import type { WaRendererProps } from './primitives';

/** Group/system events and call notices render as a centred grey pill rather
 *  than a chat bubble. `capabilities.pill` tells the thread to centre it. */
export function SystemMessage({ view }: WaRendererProps) {
  return (
    <Box
      style={{
        padding: '4px 14px',
        borderRadius: 999,
        background: 'light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-6))',
        border: '1px solid light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-4))',
        fontSize: 11,
        fontWeight: 500,
        color: 'var(--mantine-color-dimmed)',
        maxWidth: '70%',
        textAlign: 'center',
      }}
    >
      {view.body ?? view.fallbackLabel}
    </Box>
  );
}
